class CompareOffcanvas extends HTMLElement {
    constructor() {
      super();
      this.products = [];
      this.comparisonTable = this.querySelector(".product-comparison-table");
      this.popupLoading = "popup--loading";
      this.sectionId = this.dataset.sectionId;
      this.comparePopup = document.getElementById("ComparePopup");
      this.closeBtn = document.querySelector(".product-popup-modal__toggle");
      this.popupOverlay = document.querySelector(".product-compare-popup__overlay");
      this.boundModalShow = this.modalShow.bind(this);
      this.boundHandleCompareClick = this.handleCompareClick.bind(this);
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:select", (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.modalShow();
          }
        });
        document.addEventListener("shopify:section:deselect", (event) => {
          if (event.detail.sectionId === this.sectionId) {
            this.modalHide();
          }
        });
      }
    }
    connectedCallback() {
      setTimeout(() => {
        this.initializeComparison();
      }, 100);
      // Use event delegation on document to handle compare button clicks
      // This ensures it works in design mode when sections are re-rendered
      document.addEventListener("click", this.boundHandleCompareClick);
      this.popupOverlay.addEventListener("click", this.modalHide.bind(this));
      this.closeBtn.addEventListener("click", this.modalHide.bind(this));
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.modalHide();
      })
      window.addEventListener("compare-products-changed", this.onProductsChanged.bind(this));
    }
    disconnectedCallback() {
      document.removeEventListener("click", this.boundHandleCompareClick);
      window.removeEventListener("compare-products-changed", this.onProductsChanged.bind(this));
    }
    handleCompareClick(event) {
      const compareBtn = event.target.closest(".button--compare");
      if (compareBtn && !compareBtn.disabled) {
        event.preventDefault();
        this.modalShow();
      }
    }
    async initializeComparison() {
      try {
        this.addClass(this.popupLoading);
        this.cleanupInitialTable();
        this.products = Utils.getSelectedProduct();
        this.products = this.products.filter(product => 
          product && product.id && product.url
        );
        
        await this.getProducts(this.products);
        
      } catch (error) {
        console.error('Error initializing comparison:', error);
        this.removeClass(this.popupLoading);
      }
    }
  
    onProductsChanged(event) {
      const newProducts = event.detail;
      const addedProducts = newProducts.filter(
        p => !this.products.some(existing => existing.id === p.id)
      );
      const removedProducts = this.products.filter(
        p => !newProducts.some(np => np.id === p.id)
      );
  
      if (!Shopify.designMode && newProducts.length < 2 && this.hasAttribute('open')) {
        this.modalHide();
        return;
      }
  
      if (removedProducts.length > 0 && addedProducts.length === 0) {
        this.handleProductRemoval(removedProducts, newProducts);
        return;
      }
  
      if (addedProducts.length > 0 && removedProducts.length === 0) {
        this.handleProductAddition(addedProducts, newProducts);
        return;
      }
  
      this.products = newProducts;
      this.initializeComparison();
    }
  
    handleProductRemoval(removedProducts, newProducts) {
      
      removedProducts.forEach(removedProduct => {
        const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
        
        const productIndex = this.products.findIndex(p => p.id === removedProduct.id);
        
        if (productIndex !== -1) {
          tableRows.forEach(row => {
            const cellToRemove = row.querySelector(`[data-product-index="${productIndex}"]`);
            if (cellToRemove) {
              cellToRemove.remove();
            }
          });
          tableRows.forEach(row => {
            const cells = row.querySelectorAll('[data-product-index]');
            cells.forEach(cell => {
              const currentIndex = parseInt(cell.getAttribute('data-product-index'));
              if (currentIndex > productIndex) {
                cell.setAttribute('data-product-index', (currentIndex - 1).toString());
              }
            });
          });
        }
      });
  
      if (Shopify.designMode) {
        this.removePlaceholdersFromModal();
        this.addPlaceholdersToModal(newProducts.length);
      } else {
        this.addPlaceholdersToModal(newProducts.length);
      }
      
      this.products = newProducts;
    }
  
    async handleProductAddition(addedProducts, newProducts) {
      
      if (Shopify.designMode) {
        this.removePlaceholdersFromModal();
      }
  
      let currentIndex = this.products.length;
      
      for (const addedProduct of addedProducts) {
        await this.addProductToModal(addedProduct, currentIndex);
        currentIndex++;
      }
      
      if (Shopify.designMode) {
        this.addPlaceholdersToModal(newProducts.length);
      } else {
        this.removePlaceholdersFromModal();
      }
      
      this.products = newProducts;
    }
  
    async addProductToModal(product, productIndex) {
      try {
        const compareRows = await this.fetchProduct([product]);
        
        if (compareRows.length > 0) {
          const compareRow = compareRows[0];
          const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
          const templateRows = compareRow.querySelectorAll('tr');
          
          tableRows.forEach((tableRow, rowIndex) => {
            const compareTr = tableRow.dataset.productTr;
            if (!compareTr) return;
            
            let matchingTemplateRow = null;
            templateRows.forEach(templateRow => {
              const templateCell = templateRow.querySelector(`td[data-product-tr="${compareTr}"]`);
              if (templateCell) {
                matchingTemplateRow = templateCell;
              }
            });
            
            if (matchingTemplateRow) {
              const clonedCell = matchingTemplateRow.cloneNode(true);
              clonedCell.classList.add('comparison-value');
              clonedCell.setAttribute('data-product-index', productIndex);
              
              this.addRemoveButtonFunctionality(clonedCell, product.id);
              
              const existingCells = tableRow.querySelectorAll('[data-product-index]');
              const placeholderCells = tableRow.querySelectorAll('.placeholder-cell');
              
              if (placeholderCells.length > 0) {
                tableRow.insertBefore(clonedCell, placeholderCells[0]);
              } else {
                tableRow.appendChild(clonedCell);
              }
            } else {
              const emptyCell = document.createElement('td');
              emptyCell.classList.add('comparison-value');
              emptyCell.setAttribute('data-product-index', productIndex);
              emptyCell.textContent = '-';
              
              const placeholderCells = tableRow.querySelectorAll('.placeholder-cell');
              if (placeholderCells.length > 0) {
                tableRow.insertBefore(emptyCell, placeholderCells[0]);
              } else {
                tableRow.appendChild(emptyCell);
              }
            }
          });
        }
      } catch (error) {
        console.error('Error adding product to modal:', error);
      }
    }
  
    addPlaceholdersToModal(currentProductCount) {
      if (Shopify.designMode) {
        let placeholdersNeeded = 0;
        
        if (currentProductCount === 0) {
          placeholdersNeeded = 3;
        } else if (currentProductCount === 1) {
          placeholdersNeeded = 2;
        } else {
          placeholdersNeeded = 0;
        }
        
        if (placeholdersNeeded > 0) {
          const placeholderRows = this.getCompareTablePlaceholderRows(placeholdersNeeded);
          const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
          
          placeholderRows.forEach((placeholderRow, placeholderIndex) => {
            const templateRows = placeholderRow.querySelectorAll('tr');
            const placeholderProductIndex = currentProductCount + placeholderIndex;
            
            tableRows.forEach((tableRow) => {
              const compareTr = tableRow.dataset.productTr;
              if (!compareTr) return;
              
              let matchingTemplateRow = null;
              templateRows.forEach(templateRow => {
                const templateCell = templateRow.querySelector(`td[data-product-tr="${compareTr}"]`);
                if (templateCell) {
                  matchingTemplateRow = templateCell;
                }
              });
              
              if (matchingTemplateRow) {
                const clonedCell = matchingTemplateRow.cloneNode(true);
                clonedCell.classList.add('comparison-value', 'placeholder-cell');
                clonedCell.setAttribute('data-product-index', placeholderProductIndex);
                tableRow.appendChild(clonedCell);
              }
            });
          });
        }
      }
    }
  
    removePlaceholdersFromModal() {
      const placeholderCells = this.comparisonTable.querySelectorAll('.placeholder-cell');
      placeholderCells.forEach(cell => cell.remove());
    }
    get sourceSelector() {
      return "#MainProduct-compare__rows";
    }
    get placeholderSelector() {
      return "#MainProduct-compare__placeholder";
    }
    async getProducts() {
      try {
        const products = this.products;
        const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
        
        if (!tableRows.length) {
          console.error('No table rows found in comparison table');
          this.removeClass(this.popupLoading);
          return;
        }
        
        this.clearExistingComparisonColumns();
        let compareRows = [];
        
        if (products.length > 0) {
          compareRows = await this.fetchProduct(products);
        }
        
        if (Shopify.designMode) {
          let placeholdersNeeded = 0;
          
          if (products.length === 0) {
            placeholdersNeeded = 3;
          } else if (products.length === 1) {
            placeholdersNeeded = 2;
          } else {
            placeholdersNeeded = 0;
          }
  
          if (placeholdersNeeded > 0) {
            const placeholderRows = this.getCompareTablePlaceholderRows(placeholdersNeeded);
            compareRows.push(...placeholderRows);
          }
        } else if (products.length === 0) {
          const placeholderRows = this.getCompareTablePlaceholderRows(3);
          compareRows.push(...placeholderRows);
        }
  
        if (!compareRows.length && products.length === 0) {
          const placeholderRows = this.getCompareTablePlaceholderRows(3);
          compareRows.push(...placeholderRows);
        }
        compareRows.forEach((compareRow, productIndex) => {
          if (!compareRow) {
            console.warn(`Empty compareRow at index ${productIndex}`);
            return;
          }
          
          const templateRows = compareRow.querySelectorAll('tr');
          const isPlaceholder = productIndex >= products.length;
          
          tableRows.forEach((tableRow, rowIndex) => {
            const compareTr = tableRow.dataset.productTr;
            if (!compareTr) return;
            
            let matchingTemplateRow = null;
            templateRows.forEach(templateRow => {
              const templateCell = templateRow.querySelector(`td[data-product-tr="${compareTr}"]`);
              if (templateCell) {
                matchingTemplateRow = templateCell;
              }
            });
            
            if (matchingTemplateRow) {
              const clonedCell = matchingTemplateRow.cloneNode(true);
              clonedCell.classList.add('comparison-value');
              if (isPlaceholder) {
                clonedCell.classList.add('placeholder-cell');
              }
              
              clonedCell.setAttribute('data-product-index', productIndex);
              
              if (!isPlaceholder && productIndex < products.length) {
                this.addRemoveButtonFunctionality(clonedCell, products[productIndex].id);
              }
              
              tableRow.appendChild(clonedCell);
            } else {
              const emptyCell = document.createElement('td');
              emptyCell.classList.add('comparison-value');
          
              if (isPlaceholder) {
                emptyCell.classList.add('placeholder-cell');
              }
              
              emptyCell.setAttribute('data-product-index', productIndex);
              emptyCell.textContent = '-';
              tableRow.appendChild(emptyCell);
            }
          });
        });
        setTimeout(() => {
          this.removeClass(this.popupLoading);
        }, 300);
        
      } catch (error) {
        console.error('Error in getProducts:', error);
        this.removeClass(this.popupLoading);
      }
    }
    
    addRemoveButtonFunctionality(cell, productId) {
      const removeBtn = cell.querySelector(".comparison-remove-btn, .sticky--item-remove, [class*='remove']");
      if (removeBtn) {
        const handleRemove = (e) => {
          e.preventDefault();
          e.stopPropagation();
          Utils.removeFromProductList(productId);
        };
        removeBtn.addEventListener("click", handleRemove);
        removeBtn._removeHandler = handleRemove;
      }
    }
    
    clearExistingComparisonColumns() {
      const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
      tableRows.forEach(row => {
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, index) => {
          if (index > 0 && !cell.classList.contains('comparison-label')) {
            if (cell.classList.contains('comparison-value') || 
                cell.hasAttribute('data-product-index')) {
              cell.remove();
            }
          }
        });
      });
    }
    async fetchProduct(products) {
      const templates = {};
      try {
        const fetchPromises = products.map(async (product) => {
          try {
            if (!product || !product.id || !product.url) {
              console.warn('Invalid product data:', product);
              return null;
            }
            const sectionParam = this.sectionId ? `?section_id=${this.sectionId}` : '?section_id=product-compare-popup';
            const response = await fetch(`${product.url}${sectionParam}`);
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status} for product ${product.id}`);
            }
            const responseText = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(responseText, "text/html");
            const rowTemplate = doc.querySelector(this.sourceSelector);
            if (rowTemplate && rowTemplate.content) {
              templates[product.id] = rowTemplate.content.cloneNode(true);
              return { id: product.id, success: true };
            } else {
              console.warn(`No template found for product ID: ${product.id}`);
              return { id: product.id, success: false };
            }
          } catch (error) {
            console.error(`Error fetching product ID ${product.id}:`, error);
            return { id: product.id, success: false, error };
          }
        });
        await Promise.all(fetchPromises);
        const orderedTemplates = [];
        products.forEach((product) => {
          if (product && product.id && templates[product.id]) {
            orderedTemplates.push(templates[product.id]);
          } else {
            console.warn(`Template missing for product:`, product);
            orderedTemplates.push(null);
          }
        });
        return orderedTemplates;
      } catch (error) {
        console.error("Error in fetchProduct:", error);
        return [];
      }
    }
    validateProducts(products) {
      return products.filter(product => {
        if (!product) {
          console.warn('Null product found');
          return false;
        }
        if (!product.id) {
          console.warn('Product without ID:', product);
          return false;
        }
        if (!product.url) {
          console.warn('Product without URL:', product);
          return false;
        }
        return true;
      });
    }
    async refreshComparison() {
      this.clearExistingComparisonColumns();
      await this.initializeComparison();
    }
    cleanupInitialTable() {
      const tableRows = this.comparisonTable.querySelectorAll("tbody tr");
      tableRows.forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length > 2) {
          const secondCell = cells[1];
          const hasProductTr = secondCell.hasAttribute('data-product-tr');
          if (!hasProductTr && cells.length > 2) {
            for (let i = 2; i < cells.length; i++) {
              cells[i].remove();
            }
          }
        }
      });
    }
    modalShow(opener) {
      document.body.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      window.pauseAllMedia();
    }
    modalHide() {
      document.body.classList.remove("overflow-hidden");
      this.removeAttribute("open");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      window.pauseAllMedia();
    }
    getCompareTablePlaceholderRows(number){
      const rowTemplate = document.querySelector(this.placeholderSelector)
      let returns = [];
      for (let i = 0; i < number; i++)
      returns.push(rowTemplate.content.cloneNode(true));
      return returns;
    }
    addClass(className) {
      this.classList.add(className);
    }
    
    removeClass(className) {
      this.classList.remove(className);
    }
  }
  customElements.define("product-compare-popup", CompareOffcanvas);